import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { mergeMap, tap } from 'rxjs/operators';
import { BaseService, IServiceUrlConfig } from '../../../core/services/base/base.service';
import { CMSSite } from '../models/cms-site';

@Injectable({
  providedIn: 'root',
})
export class CMSService extends BaseService<CMSSite> {
  constructor() {
    super(inject(HttpClient), CMSSite);
  }

  public arrange(order: Array<string>) {
    return this.apiStrategy.getHeaders().pipe(
      mergeMap((headers) => {
        return this.http
          .post<void>(
            this.getServiceUrl('', {
              mgmt: true,
              path: ['arrange'],
            }),
            { order },
            {
              headers,
            },
          )
          .pipe(
            tap(() => {
              this.triggerReload();
            }),
          );
      }),
    );
  }

  protected getServiceUrl(entityId: string, serviceUrlConfig?: IServiceUrlConfig): string {
    const url = this.generateServiceURL('cms-site', entityId, serviceUrlConfig);
    return this.apiStrategy.getServiceUrl(url);
  }
}
